function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  cx: "50%",
  cy: "0%",
  fx: "50%",
  fy: "0%",
  r: "100%",
  gradientTransform: "translate(0.500000,0.000000),scale(0.870370,1.000000),rotate(90.000000),scale(1.000000,2.174399),translate(-0.500000,-0.000000)",
  id: "inline-svg-18-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7C00",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F76600",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "-2.48949813e-15%",
  x2: "50%",
  y2: "100%",
  id: "inline-svg-18-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F57600",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA6000",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "inline-svg-18-3",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "inline-svg-18-4",
  transform: "translate(-339.000000, -18.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "inline-svg-18-5",
  transform: "translate(-1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "inline-svg-18-6",
  transform: "translate(322.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5,25 L36.5,25 C37.3284271,25 38,25.6715729 38,26.5 C38,27.3284271 37.3284271,28 36.5,28 L19.5,28 C18.6715729,28 18,27.3284271 18,26.5 C18,25.6715729 18.6715729,25 19.5,25 L19.5,25 Z M19.5,18 L36.5,18 L36.5,18 C37.3284271,18 38,18.6715729 38,19.5 L38,19.5 C38,20.3284271 37.3284271,21 36.5,21 L19.5,21 C18.6715729,21 18,20.3284271 18,19.5 L18,19.5 L18,19.5 C18,18.6715729 18.6715729,18 19.5,18 L19.5,18 Z",
  id: "inline-svg-18-7"
})))));

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "10px",
    viewBox: "0 0 20 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.44b89f9265eae1b96b3d74b81f47a325.svg";
export { ForwardRef as ReactComponent };